import {Theme} from '../ThemeProvider';

export type IsContained = boolean | 'lg' | 'xl';

export const getContainerMaxWidth = (theme: Theme, isContained?: IsContained): 'auto' | number => {
    if (!isContained) {
        return 'auto';
    }

    const containerSize = isContained === true ? 'lg' : isContained;

    return theme.breakpoints.values[containerSize];
};
